import { endOfDay, subYears } from "date-fns";
import { assignDefaultValue } from "features/contracting/helpers/contractingFormHelper";
import { CustomerType } from "features/customer/enums/customerType";
import FormGroupTooltip from "features/shared/forms/components/formGroup/FormGroupTooltip";
import { assignPhoneInputPrefixDefault } from "features/shared/forms/components/phoneInput/phoneInputConfig";
import { FormFields, GetFormValueFunction } from "features/shared/forms/hooks/useForm";
import { TFunction } from "i18next";
import _ from "lodash";

// constants
export const mainAddressKey = "mainAddress";
export const correspondenceAddressKey = "correspondenceAddress";
export const authorizedAgentKey = "authorizedAgent";
export const contactPersonKey = "contactPerson";

// functions
export const isBusinessType = (customerType: CustomerType): boolean => {
  return customerType === "Company";
};

export const getFormInitValues = (storeValues: FormFields, customerType: CustomerType,) => {
  // assign mobile input prefix
  let defaultValues = assignPhoneInputPrefixDefault(
    storeValues,
    "mobilePrefix"
  );
  // assign contact person same as authorized agent (only business customer)
  if (isBusinessType(customerType)) {
    defaultValues = assignDefaultValue(
      defaultValues,
      "contactPersonIsSameAsAuthorizedAgent",
      true
    );
  }
  // assign correspondence address same as main address
  defaultValues = assignDefaultValue(
    defaultValues,
    "correspondenceAddressIsSameAsMain",
    true
  );

  return defaultValues;
};

export const hasCorrespondenceAddress = (getFormValue: GetFormValueFunction) => { 
  const addressIsSameAsMain = getFormValue<boolean>("correspondenceAddressIsSameAsMain");
  return addressIsSameAsMain === false;
}

export const hasContactPerson = (getFormValue: GetFormValueFunction) => { 
  const isSame = getFormValue<boolean>("contactPersonIsSameAsAuthorizedAgent");
  return isSame === false;
}

export const getDateOfBirthMaxDate = () => {
  return subYears(endOfDay(new Date()), 18);
}

export const getMobileInfoTooltip = (t: TFunction, enabled: boolean = true): FormGroupTooltip | undefined => {
  if (enabled) {
    return {
      id: "customerDataForm-mobileNumber-tooltip",
      content: t("customerDataFormSection.mobileInfoTooltip"),
      placement: "top",
    };
  }
  return undefined;
};